import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import BlockRenderer from "../components/BlockRenderer";
import PageIntro from "../components/IntroBlock";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

function PreviewPage() {
  const { pageSlug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    axios
      .get(`${API_BASE_URL}/api/page/?slug=${pageSlug}`)
      .then(response => {
        setData(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching preview data:", error);
        setLoading(false);
      });
  }, [pageSlug]);

  return (
    <div className="container mx-auto p-4">
      {loading ? (
        <p>Loading preview...</p>
      ) : data ? (
        <div>
          <PageIntro customTitle={data.custom_title} description={data.description} />
          {data.body && <BlockRenderer blocks={data.body} />}
        </div>
      ) : (
        <p>Error loading preview.</p>
      )}
    </div>
  );
}

export default PreviewPage;
